(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/actions/clear-storage.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/actions/clear-storage.js');
"use strict";


const clearStorage = callback => (callbackFn, timeout) => {
  callback(undefined, callbackFn, timeout);
};
setGlobal('svs.components.selfserviceCart.fns.actions.clearStorage', clearStorage);

 })(window);